import clsx from "clsx";
import React from "react";

export const TYPOGRAPHY_VARIANT = {
  h1: "text-h1",
  h2: "text-h2",
  h3: "text-h3",
  h4: "text-h4",
  h5: "text-h5",
  h6: "text-h6",
  parag1: "text-parag1",
  parag2: "text-parag2",
  parag3: "text-parag3",
  parag4: "text-parag4",
};

export interface IProps {
  color?: "primary" | "secondary" | string;
  variant?: keyof typeof TYPOGRAPHY_VARIANT;
  className?: string;
  style?: React.CSSProperties;
  component?: React.ElementType;
  noWrap?: boolean;
  id?: string;
  onClick?: VoidFunction;
  dangerouslySetInnerHTML?: any;
}

const getColor = (color: IProps["color"]) => {
  if (color === "primary") return { colorClassName: "dark:text-white" };

  if (color === "secondary")
    return { colorClassName: "text-text-secondary dark:text-white/70" };

  return { colorStyle: color };
};

export const Typography = ({
  className,
  style,
  children,
  color = "primary",
  variant = "parag1",
  component: Component = "p",
  noWrap = false,
  id,
  onClick,
  dangerouslySetInnerHTML,
}: React.PropsWithChildren<IProps>) => {
  const { colorClassName, colorStyle } = getColor(color);

  return (
    <Component
      className={clsx(
        TYPOGRAPHY_VARIANT[variant],
        colorClassName,
        noWrap && "overflow-hidden text-ellipsis max-w-full whitespace-nowrap",
        className
      )}
      onClick={onClick}
      id={id}
      style={{
        color: colorStyle,
        ...style,
      }}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    >
      {children}
    </Component>
  );
};
